import { useReveal } from '@ccg/core';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Typography$1 from '../../basics/Typography/Typography.js';
import Caption$1 from '../Caption/Caption.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import StyledMediaContent from './MediaContent.style.js';

/* eslint-disable react/jsx-one-expression-per-line, react/no-array-index-key */

const MediaContent = ({
  className,
  hasFocalPoint,
  variant,
  caption,
  credits,
  children,
  noReveal,
  inline
}) => {
  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledMediaContent, {
    className: className,
    variant: variant,
    inline: inline,
    hasFocalPoint: hasFocalPoint,
    ref: ref
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "mediaContent__media-wrapper"
  }, noReveal ? children : /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible
  }, children), credits && /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "small",
    className: "mediaContent__credits"
  }, credits)), (caption || credits) && /*#__PURE__*/React$1.createElement(Caption$1, {
    className: "mediaContent__meta",
    caption: caption,
    isVisible: isVisible
  }));
};

MediaContent.propTypes = {
  className: PropTypes$1.string,
  hasFocalPoint: PropTypes$1.bool,
  credits: PropTypes$1.string,
  variant: PropTypes$1.oneOf(['s', 'm', 'l', 'xl']),
  caption: PropTypes$1.string,
  children: PropTypes$1.node,
  noReveal: PropTypes$1.bool,
  inline: PropTypes$1.bool
};
MediaContent.defaultProps = {
  className: '',
  hasFocalPoint: false,
  credits: null,
  variant: 'm',
  caption: null,
  children: null,
  noReveal: false,
  inline: false
};

export default MediaContent;
